import React, { useMemo } from "react";
import { Button, Divider, Modal } from "antd";

import TextInfo from "../../../../../../components/common/TextInfo/TextInfo";
import {
  AuthorizationList,
  CanAccess,
} from "../../../../../../components/template/authorization/Authorization";

const ProcessDialog = ({
  visible,
  handleCancel,
  handleSave,
  actionButtonText,
  title,
  onSelectChange,
  errors,
  data,
  summaryData,
  bankOptions,
  onImageChange,
  handleUploadImage,
  transferProofImg,
}) => {
  const bankOrAccNumber = useMemo(() => {
    const temp = summaryData?.loanInfo?.bankOrAccountNumber?.split("/");
    return {
      bankName: temp?.[0]?.trim(),
      accNumber: temp?.[1]?.trim(),
    };
  }, [summaryData?.loanInfo?.bankOrAccountNumber]);

  return (
    <Modal
      className="modal-form"
      title={title}
      visible={visible}
      onCancel={handleCancel}
      width={"30%"}
      centered
      footer={[
        <Button
          key="back"
          onClick={handleCancel}
          className="btn-modal btn-default"
        >
          Kembali
        </Button>,
        <CanAccess
          role={AuthorizationList.update_waiting_disburse}
          yes={
            <Button
              key="submit"
              type="primary"
              onClick={handleSave}
              className="btn-modal"
            >
              {actionButtonText}
            </Button>
          }
        />,
      ]}
    >
      <div className="modal-form-content" style={{ gap: "0px" }}>
        <TextInfo
          title="Tanggal/Waktu"
          value={summaryData?.loanInfo?.transactionDate}
        />
        <TextInfo
          title="No. Surat Bukti Gadai"
          value={summaryData?.headerInfo?.sbgCode}
        />
        <TextInfo
          title="No. Kwitansi"
          value={summaryData?.headerInfo?.receiptNumber}
        />
        <TextInfo
          title="Nama Nasabah"
          value={summaryData?.headerInfo?.customerName}
        />
        <TextInfo title="NIK" value={summaryData?.loanInfo?.customerNIK} />
        <TextInfo
          title="No. Telepon"
          value={`${summaryData?.headerInfo?.customerPhone1} / ${summaryData?.headerInfo?.customerPhone2}`}
        />
        <TextInfo
          title="Barang Jaminan"
          value={summaryData?.loanInfo?.product}
        />
      </div>
      <Divider dashed className="detail-divider" />
      <div className="modal-form-content" style={{ gap: "0px" }}>
        <TextInfo title="Bank" value={bankOrAccNumber.bankName} />
        <TextInfo title="No. Rekening" value={bankOrAccNumber.accNumber} />
        <TextInfo
          title="Atas Nama"
          value={summaryData?.loanInfo?.accountName}
        />
        <TextInfo
          title="Nilai Pinjaman"
          value={summaryData?.loanSummary?.loanAmount}
        />
        <TextInfo
          title="Sewa Modal"
          value={summaryData?.loanSummary?.capitalLoan}
        />
        <TextInfo
          title="Biaya Administrasi"
          value={summaryData?.loanSummary?.feeAdmin}
        />
        <TextInfo
          title="Biaya Simpan & Asuransi"
          value={summaryData?.loanSummary?.feeSavingAssurance}
        />
        <TextInfo
          title="Jumlah Diterima"
          value={summaryData?.loanSummary?.takenAmount}
        />
        <TextInfo
          title="Tanggal Jatuh Tempo"
          value={summaryData?.commonInfo?.dueDate}
        />
      </div>
      <Divider dashed className="detail-divider" />
      <div className="modal-form-content" style={{ gap: "0px" }}>
        <TextInfo
          title="Bank yang Digunakan"
          value={data.bankName}
          type={"select"}
          id={"bankName"}
          handleChange={onSelectChange}
          error={errors?.bankName}
          placeholder={"Pilih Bank"}
          isSearchable
          selectOptions={bankOptions}
          isForm
        />
        <TextInfo
          title="Bukti Transfer"
          type={"upload"}
          id={"transferProof"}
          helperText="Format JPG/JPEG/PNG/PDF (Maks. 1MB)"
          handleImageChange={onImageChange("transferProof")}
          customRequest={handleUploadImage("transferProof")}
          fileList={transferProofImg}
          error={errors?.transferProof}
          isForm
        />
      </div>
    </Modal>
  );
};

export default ProcessDialog;
